
export default {
  props: {
    show: { type: Boolean, default: false },
  },
  methods: {
    url() {
      return (
        this.$config.poweredDomain + (this.$i18n.locale === 'he' ? '/he' : '/')
      )
    },
  },
}
